import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ProjectSettingsToolchainQuery, {
	type ui_projectSettingsToolchainQuery,
} from '@atlassian/jira-relay/src/__generated__/ui_projectSettingsToolchainQuery.graphql';

export const RESOURCE_TYPE_TOOLCHAIN_RELAY = 'PROJECT_SETTINGS_TOOLCHAIN';

export const projectSettingsToolchainResource =
	createRelayResource<ui_projectSettingsToolchainQuery>({
		type: RESOURCE_TYPE_TOOLCHAIN_RELAY,
		getQuery: (_, { tenantContext }) => ({
			parameters: ProjectSettingsToolchainQuery,
			variables: {
				cloudId: tenantContext?.cloudId || '',
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	});
